module.exports = __webpack_public_path__ + "img/r-176.c3614324.jpg";